import React, { useEffect } from "react";
import RecordingsScreen from "./Recordings/RecordingsScreen";
import OnlineStatusIndicator from "./shared/components/OnlineStatusIndicator";
import { useSupabase } from "./shared/supabase/supabase";
import { EmailService } from "./shared/services/EmailService";

export const Dashboard: React.FC = () => {
  const supabase = useSupabase();

  // Send onboarding email on auth state change (once per user, persisted in localStorage)
  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      // Trigger on SIGNED_IN event (covers all auth methods: Google, email signup, email signin)
      if (event === "SIGNED_IN" && session?.access_token && session?.user?.id) {
        try {
          // Check if we've already sent the onboarding notification for this user
          const onboardingKey = `onboarding_notification_sent_${session.user.id}`;
          const alreadySent = localStorage.getItem(onboardingKey);

          if (alreadySent === "true") {
            console.log(
              "[Dashboard] Onboarding notification already sent for user, skipping"
            );
            return;
          }

          console.log("[Dashboard] Sending web onboarding notification...");

          // Send the onboarding email for web signups
          await EmailService.sendOnboardingEmail(session.access_token);

          // Mark as sent in localStorage (persists across sessions)
          localStorage.setItem(onboardingKey, "true");
          console.log("[Dashboard] ✅ Onboarding notification sent successfully");
        } catch (error) {
          console.error("[Dashboard] Failed to send onboarding email:", error);
          // Don't set localStorage on failure so it can retry
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [supabase.auth]);

  return (
    <>
      <OnlineStatusIndicator />
      <RecordingsScreen />
    </>
  );
};
